import React from "react";
import { INDUSTRIES } from "../mock";
import { PageHero, Eyebrow, Icon, CtaBanner, Reveal } from "../components/shared";
import { SimpleServiceGrid } from "../components/ServiceCards";

export default function IndustriesPage() {
  return (
    <>
      <PageHero
        crumb="Industries"
        eyebrow="Industries We Serve"
        title="Supporting a Wide Range of Sectors"
        subtitle="We work across commercial, industrial, public sector, and residential environments — adapting each installation to how the building is actually used."
      />

      <section className="py-20 lg:py-24 bg-white">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={i} delay={(i % 4) * 70} className="group bg-white rounded-2xl border border-black/5 p-6 hover:shadow-lg hover:-translate-y-1 transition-all">
                <div className="w-14 h-14 flex items-center justify-center mb-8">
                  <Icon name={ind.icon} className="w-12 h-12 text-[#1e73ff]" />
                </div>
                <h3 className="font-display font-bold text-[17px] text-[#0b2545]">{ind.title}</h3>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-[#eaf2ff]">
        <div className="max-w-[1240px] mx-auto px-5 lg:px-8">
          <Eyebrow className="mb-5">Our Services</Eyebrow>
          <h2 className="font-display font-extrabold text-[#0b2545] text-[38px] lg:text-[56px] hero-heading max-w-xl mb-14">
            What we install and support
          </h2>
          <SimpleServiceGrid />
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
